<template>
  <section class="extra-about-component">
    <div class="container oversized-container">
      <div class="row justify-content-between">
        <div class="col-12 col-title">
          <h2 class="text-center title-s1">Descubre Bazaar Flex</h2>
        </div>

        <div class="col-sm-4 col-box" data-aos="fade-up">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/home/icon-1.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Envíos gratis.</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 col-box" data-aos="fade-up" data-aos-delay="50">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/home/icon-2.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Compras seguras.</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 col-box" data-aos="fade-up" data-aos-delay="100">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/home/icon-3.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Asistencia Inmediata.</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 col-box" data-aos="fade-up" data-aos-delay="150">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/home/icon-4.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Opciones de pago.</h6>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-4 col-box" data-aos="fade-up" data-aos-delay="200">
          <div class="inside">
            <div class="box-image">
              <img src="public/images/pages/home/icon-5.png">
            </div>

            <div class="box-text">
              <div>
                <h6>Productores Mexicanos.</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'ExtraInfoComponent'
}
</script>